import { productFilteringRequest } from "VueInterfaces/ProductFilteringInterfaces";
import { wishlistRequest } from "VueInterfaces/WishlistInterfaces";
import { useToast } from "vue-toastification";
const toast = useToast();


/**
 * This function takes in a query paramater and hits and endpoint and returns back search results
 * @param query = The value of the search input
 * @constructor
 */
export const GetSearchData = async (query) => {
	try {
		let url: any = new URL(`${window.location.protocol}//${window.location.host}/api/we/search?query=${query}`);
		const response = await fetch(url);

		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		return err;
	}
}


export const FilterRequest = async (filterRequest:productFilteringRequest) => {
	let url: any = new URL(`${window.location.protocol}//${window.location.host}/api/we/product-filtering`);

	try {
		const fetchResponse = await fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(filterRequest)
		});
		const response = await fetchResponse.json();
		if(response.errorDetail?.isError) {
			response.errorDetail?.messages.forEach((error) => {
				toast.error(error, {
					timeout: 5000
				});
			});
			return;
		}
		return response.data;
	} catch (err) {
		toast.error(`There was a problem with the checkout endpoint: ${err}`, {
			timeout: 5000
		});
		return err;
	}
}

/* PRODUCT FAMILY REQUEST */
export const FamilyRequest = async (category:string, groupBy:string = '', language:string = '', type:string = '', selectedFinishes:any = '') => {
	try {
		let url: any = new URL(`${window.location.protocol}//${window.location.host}/api/we/category-browse?category=${category}&GroupBy=${groupBy}&language=${language}&type=${type}&selectedFinishes=${selectedFinishes}`);
		const response = await fetch(url);

		const rsp = await response.json();
		if (rsp.errorMessages?.length) {
			rsp.errorMessages.forEach((error) => {
				console.log(error.message);
			});
			return;
		} else {
			return rsp;
		}
	} catch (err) {
		return err;
	}
}

/**
 * This function takes in product ids and hits and endpoint and returns back the products info *
 * @constructor
 */
 export const GetProductData = async (wishlistRequest:wishlistRequest) => {
	let url: any = new URL(`${window.location.protocol}//${window.location.host}/api/we/product`);
	try {
		const fetchResponse = await fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(wishlistRequest)
		});
		const response = await fetchResponse.json();
		if(response.errorDetail?.isError) {
			response.errorDetail?.messages.forEach((error) => {
				toast.error(error, {
					timeout: 5000
				});
			});
			return;
		}
		return response.data;
	} catch (err) {
		toast.error(`There was a problem with the checkout endpoint: ${err}`, {
			timeout: 5000
		});
		return err;
	}
}

